var map = {
	"./read-more_de": 9064,
	"./read-more_de.json": 9064,
	"./read-more_en": 3236,
	"./read-more_en.json": 3236,
	"./read-more_es": 4275,
	"./read-more_es.json": 4275,
	"./read-more_fr": 3231,
	"./read-more_fr.json": 3231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4050;